function RedStar() {
  return <span style={{ color: "red" }}>*</span>;
}

export default RedStar;